import script from "./App.vue?vue&type=script&setup=true&lang=tsx"
export * from "./App.vue?vue&type=script&setup=true&lang=tsx"

import "./App.vue?vue&type=style&index=0&id=f13f28b6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Profectus/Profectus/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f13f28b6"]])

export default __exports__